import React from 'react';
import { Box, Card, CardContent, Typography, Chip, Grid, CircularProgress, Divider } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';

const estadoColors = {
    'Disponible': 'success',
    'Reservada': 'warning',
    'En Espera': 'info',
    'Ocupada': 'error',
    'Baja': 'default',
};

const SectionCard = ({ title, items, getLabel, getColor }) => (
    <Card elevation={2} sx={{ height: '100%' }}>
        <CardContent sx={{ pb: '12px !important' }}>
            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#3c4b64', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                {title}
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                {Object.entries(items)
                    .sort((a, b) => b[1] - a[1])
                    .map(([key, count]) => (
                        <Chip
                            key={key}
                            label={`${getLabel ? getLabel(key) : key}: ${count}`}
                            color={getColor ? getColor(key) : 'default'}
                            size="small"
                            variant="outlined"
                            sx={{ fontWeight: 500, fontSize: '0.75rem' }}
                        />
                    ))}
                {Object.keys(items).length === 0 && (
                    <Typography variant="caption" color="text.secondary">Sin datos</Typography>
                )}
            </Box>
        </CardContent>
    </Card>
);

export const UbicacionesTotales = ({ summary, tiposCajas, loading }) => {
    if (loading) return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2, gap: 1 }}>
            <CircularProgress size={20} />
            <Typography variant="caption" color="text.secondary">Calculando totales...</Typography>
        </Box>
    );

    if (!summary) return null;

    const tipoCajasLabel = (id) => {
        const tc = tiposCajas?.find(t => String(t.id) === String(id));
        return tc ? `${tc.id} - ${tc.detalle || tc.nombre}` : `Tipo ${id}`;
    };

    return (
        <Box sx={{ mt: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                <BarChartIcon sx={{ color: '#3c4b64', fontSize: 20 }} />
                <Typography sx={{ fontWeight: 'bold', color: '#3c4b64', fontSize: 14 }}>
                    Totales — {summary.total} ubicaciones encontradas
                </Typography>
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <SectionCard
                        title="Por Estado"
                        items={summary.estados}
                        getColor={(key) => estadoColors[key] || 'default'}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SectionCard
                        title="Por Tipo de Cajas"
                        items={summary.tipo_cajas}
                        getLabel={tipoCajasLabel}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SectionCard
                        title="Por Tipo de Estante"
                        items={summary.tipo_estante}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default UbicacionesTotales;
